import useTheme from '@eversports/klimt-design-components/use-theme'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'
import Drawer from '@eversports/klimt-primitives/legacy/Drawer'
import useSharingMessage from './use-sharing-message'
import InviteFriendsDialogContent from './InviteFriendsDialogContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  eventId: string
}

const InviteFriendsDialog = ({ isOpen, toggleDialog, eventId }: Props) => {
  const theme = useTheme()
  const sharingMessage = useSharingMessage()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (!isOpen) return null

  return isMobile ? (
    <Drawer
      anchor="bottom"
      sx={{
        '& .MuiDrawer-paper': {
          borderRadius: '16px 16px 0px 0px',
          p: 4,
        },
      }}
      open={isOpen}
      onClose={toggleDialog}
    >
      <InviteFriendsDialogContent sharingMessage={sharingMessage} eventId={eventId} />
    </Drawer>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog}>
      <DialogContent>
        <InviteFriendsDialogContent sharingMessage={sharingMessage} eventId={eventId} />
      </DialogContent>
    </Dialog>
  )
}

export default InviteFriendsDialog
